function openModalBracingDialog() {
  document.dispatchEvent(new CustomEvent('configure-bracing-dialog'))
  $('#modal-bracing-dialog').modal('show')
}


function closeModalBracingDialog() {
  if (activeProject.beamController.isEquallySpacedBracing()) {
    if ($("#equal-bracing-spacing-input").valid() && $("#equal-bracing-start-input").valid()) {
      activeProject.beamController.addEquallySpacedBraces(
        wsParseLength(document.getElementById("equal-bracing-spacing-input").value),
        wsParseLength(document.getElementById('equal-bracing-start-input').value))
    }
  }

  $("#modal-bracing-dialog").trigger('ws_redraw')
  $('#modal-bracing-dialog').modal('hide');
  configureBracingButton()
}

function updateEquallySpacedBracingForm() {
  document.getElementById("equal-bracing-spacing-input").value = showSmallLengthWithUnits(activeProject.design.getBraceSpacing())
  document.getElementById('equal-bracing-start-input').value = showSmallLengthWithUnits(activeProject.design.getBracingStartLocation())
}

function updateCustomBracingTable() {
  // loop over braces and build a table showing them...
  let design = activeProject.design
  let str = '<table class="table">'
  for (let i in design.customBraces) {
    if (design.customBraces[i].isSupport) {
      str += "<tr class='grayout'>";
      str += "<td style='width:100px;'>";
      str += "<span class='ws-ui-disabled-font'>Brace @</span>";
      str += "</td>";
      str += "<td style='width:100px;' id='brace_" + i + "'>" + showFeetInches(design.customBraces[i].x) + "</td>";
      str += "<td style='width:100px;'><span><em>Support</em></span></td></tr>";
    } else {
      str += "<tr>";
      str += "<td style='width:100px;'>";
      str += "Brace @";
      str += "</td>";
      str += "<td style='width:100px;' id='brace_" + i + "'>" + showFeetInches(design.customBraces[i].x) + "</td>";
      str += "<td style='width:100px;'><button type='button' class='btn btn-sm btn-danger' data-toggle='modal' onclick='removeBrace(" + i + ");'>Remove</button></td></tr>";
    }
  }
  str += "<tr class='info'><td colspan=3>Note: Supports assumed braced.</td></tr>";
  str += "</table>";
  document.getElementById('custom-bracing-table').innerHTML = str
}

function addBrace() {
  if ($("#new-brace-location-input").valid()) {
    var brace = wsParseLength(document.getElementById("new-brace-location-input").value)
    activeProject.beamController.addBrace(brace, false)
    updateCustomBracingTable()
  }
}

function removeBrace(index) {
  activeProject.beamController.removeBrace(index);
  updateCustomBracingTable();
}
